import { PrismicRichText } from "@prismicio/react";
import React from "react";
import { PrismicReusableContentDataBodyTalkToAnExpert } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { clsx } from "clsx";
import { graphql } from "gatsby";
import SalesforceContactForm from "../salesforce-contact-form/salesforce-contact-form";
import CTA from "../cta/cta";
import { track } from "../../utils/analytics";
import SalesforceFormContext, {
  useSalesforceViewContext,
} from "../../utils/salesforce-form-context";

export const query = graphql`
  fragment TalkToAnExpertModule on PrismicReusableContentDataBody {
    ... on PrismicReusableContentDataBodyTalkToAnExpert {
      slice_type
      primary {
        css_class
        heading {
          richText
          text
        }
        description {
          richText
          text
        }
        cta_text
        salesforce_lead_source
        salesforce_form_disclaimer {
          richText
          text
        }
      }
    }
  }
`;

export type ITalkToAnExpertProps = {
  slice: PrismicReusableContentDataBodyTalkToAnExpert;
};

const TalkToAnExpert = (props: ITalkToAnExpertProps) => {
  console.log("TalkToAnExpert");
  const { slice } = props;
  const { primary } = slice;

  return (
    <SalesforceFormContext>
      <TalkToAnExpertContext {...props} />
    </SalesforceFormContext>
  );
};

const TalkToAnExpertContext = (props: ITalkToAnExpertProps) => {
  const { primary } = props.slice;

  // Salesforce Form Context
  const setFormViewState = useSalesforceViewContext();

  return (
    <SalesforceContactForm
      leadSource={primary.salesforce_lead_source}
      disclaimer={primary.salesforce_form_disclaimer.richText}
    >
      <div className={clsx([primary?.css_class])}>
        {primary.heading && (
          <header>
            <PrismicRichText
              field={primary.heading.richText}
              components={htmlSerializer}
            />
          </header>
        )}
        {primary.description && (
          <PrismicRichText
            field={primary.description.richText}
            components={htmlSerializer}
          />
        )}
        <div className="[&_button]:!bg-[#FFC118] [&_button]:!text-black [&_button]:!border-none">
          <CTA
            kind="primary"
            scale="large"
            page-section="hero"
            className="!text-lg px-4 py-2 rounded font-semibold"
            onClickFunction={() => {
              setFormViewState.setCurrentView("form");
              track("Talk To An Expert", {
                text: "Talk To An Expert Clicked",
              });
            }}
          >
            {primary?.cta_text}
          </CTA>
        </div>
      </div>
    </SalesforceContactForm>
  );
};

export default TalkToAnExpert;
